import { CommonModule } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import {
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { AuthService } from 'src/app/features/auth/services/auth.service';
import { MaterialModule } from '../../material.module';
import { reauthRefusalMessage } from '../../services/reauth.service';
import { NotificationService } from '../../services/notification.service';
import { ConfirmDialog } from './interfaces/confirmation';

@Component({
  selector: 'confirmation-dialog',
  templateUrl: 'confirmation-dialog.component.html',
  styleUrls: ['confirmation-dialog.component.scss'],
  imports: [CommonModule, MaterialModule, FormsModule, ReactiveFormsModule],
})
export class ConfirmationDialogComponent implements OnInit {
  passwordForm: FormGroup;
  hidePassword = true;
  isLoading = false;

  constructor(
    public dialogRef: MatDialogRef<ConfirmationDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ConfirmDialog,
    private fb: FormBuilder,
    private authService: AuthService,
    private notificationService: NotificationService,
  ) {
    this.passwordForm = this.fb.group({
      password: ['', [Validators.required, Validators.minLength(1)]],
    });
  }

  ngOnInit() {
    this.passwordForm.get('password')?.valueChanges.subscribe(() => {
    this.passwordForm.get('password')?.setErrors(null);
  });
  }

  /** Just "password": whose password it is — SSO's or this lab's — is the server's business. */
  get passwordLabel(): string {
    return this.data.passwordLabel || 'Password';
  }

  get passwordPlaceholder(): string {
    return 'Enter your password';
  }

  onClose() {
    this.dialogRef.close();
  }

  confirm() {
    if (this.data.showPasswordField) {
      if (this.passwordForm.invalid) {
        this.passwordForm.get('password')?.setErrors({ invalid: true });
        return;
      }
      this.isLoading = true;
      const password = this.passwordForm.get('password')?.value;
      this.authService.stepUpAuthentication(password).subscribe({
        next: (response) => {
          this.dialogRef.close({ confirmed: true });
          this.isLoading = false;
        },
        error: (err) => {
          const code = err?.error?.message;
          const refusal = reauthRefusalMessage(code);
          if (code == 'AUTHORIZATION.INVALID') {
            this.passwordForm.get('password')?.setErrors({ invalid: true });
          } else if (refusal) {
            this.notificationService.error(refusal);
          } else {
            this.notificationService.error('An error occurred during authentication. Please try again.');
          }

          this.isLoading = false;
        },
      });
    } else {
      this.dialogRef.close(true);
    }
  }
}
